//NODE
import "bootstrap";

//GLOBAl LIBRARIES
import isotope from "./libs/isotope.js";
import Splide from "@splidejs/splide";
import "./libs/splide.js";
